import axios from 'axios';

const API_URL = 'http://localhost:5000/api/analysis/';

/**
 * Get the auth token from localStorage
 * @returns {object} Auth config object for axios
 */
const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    // Return the config object with the Bearer token
    return { headers: { Authorization: `Bearer ${user.token}` } };
  } else {
    return {};
  }
};

/**
 * Upload a tree image for analysis
 * @param {string} treeId The ID of the tree
 * @param {File} file The image file to upload
 */
const uploadTreeMedia = async (treeId, file) => {
  // We need to send FormData when uploading files
  const formData = new FormData();
  // 'treeImage' must match the name in our backend multer config
  formData.append('treeImage', file);

  // Get auth headers
  const config = getAuthHeader();

  // Set content-type to multipart/form-data
  config.headers['Content-Type'] = 'multipart/form-data';

  const response = await axios.post(API_URL + treeId, formData, config);
  return response.data;
};

const analysisService = {
  uploadTreeMedia,
};

export default analysisService;